import { createJSONStorage, persist } from 'zustand/middleware';
import { create } from 'zustand';
import { safeSessionStorage } from '@pkgs/components/utils/storageUtils';
import { type Language } from '@generated/search-bff';

export interface ExposeLanguageStoreState {
  exposeLanguage?: Language;
  setExposeLanguage: (language: Language) => void;
}

export const useExposeLanguageStore = create(
  persist<ExposeLanguageStoreState>(
    (set) => ({
      exposeLanguage: undefined,
      setExposeLanguage: (language: Language) => set({ exposeLanguage: language }),
    }),
    {
      name: 'expose-language',
      storage: createJSONStorage(() => safeSessionStorage),
    },
  ),
);
